<template>
  <div class="card shadow rounded border-0 mb-3 pricing-rates business-rate" v-for="schedule in schedulesHistory">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-2 text-center text-md-start">

              <img v-if="schedule.prof_photo"
                   :src="url(schedule.prof_photo)"
                   class="avatar avatar-md-md shadow-md rounded-circle"
                   alt="Foto do profissional">

              <img v-else src="../../assets/images/no-photo.png"
                   class="avatar avatar-md-md shadow-md rounded-circle"
                   alt="Foto do profissional">

            </div>
            <div class="col-md-5 text-start">
              <p class="text-dark text-center text-md-start">
                {{ schedule.prof_name }} <br>
                <span class="badge bg-primary">{{ schedule.spec_name }}</span>
              </p>
              <p class="text-dark">
                <b>Local: </b> <br>
                <span class="text-dark">{{ schedule.place_name }}</span> <br>
                <b>Endereço: </b> <br>
                {{ schedule.place_address }}
              </p>
            </div>
            <div class="col-md-5 text-start">
              <p class="text-dark">
                <b>Data e Hora: </b> <br>
                {{ date(schedule.sched_datetime_patient).format('DD/MM/YYYY HH:mm') }}
                <br>
                <br>

                <span v-if="schedule.sched_value > 0">
                                                            <b>Valor: </b>
                                                            <br>
                                                            R$ {{
                    schedule.sched_value.toLocaleString('pt-br', {
                      style: 'decimal',
                      minimumFractionDigits: 2
                    }) ?? '0'
                  }} <br>
                                                        </span>

                <b>Forma de pagamento: </b>
                <br>
                {{ schedule.paymeth_name }} <br>

                <b>Status: </b>
                <br>
                {{ schedule.status }} <br>

                <b>Paciente: </b> <br>
                {{ schedule.patient_name }} <br>
                <span v-if="schedule.avail_online" class="badge bg-primary"> Online </span>
              </p>
            </div>
          </div>
          <div class="col-md-12 text-center">
            <p class="alert-danger rounded h4" v-if="schedule.sched_status === 'CA'">Consulta Cancelada</p>
            <button type="button" @click="goToScheduleReturn(schedule)"
                    class="btn btn-secondary me-1 mt-1 mb-1"
                    v-if="schedule.allow_return">
              Agendar Retorno
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import date from "@/helpers/date";
import str from "@/helpers/str";

export default {
  name: "HistorySchedules",
  data() {
    return {
      schedulesHistory: [],
    };
  },
  mounted() {
    this.loadSchedulesHistory();
  },
  computed: {
    userAuth() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    date: date,
    url(path) {
      return str.url(path)
    },
    loadSchedulesHistory() {
      http.get(`/users/${this.userAuth.id_user}/schedules/history`).then((response) => {
        this.schedulesHistory = response.data;
      });
    },
    goToScheduleReturn(schedule) {
      this.$router.push({
        path: `/schedules/${schedule.id_sched}/return`,
        query: { from: 'history' },
      });
    },
  }
}
</script>

<style scoped>

</style>
